import { Base, router } from '@codesuma/baseline'
import { Bar } from '../bar'
import { ripple } from '../../utils/ripple'
import style from './index.module.css'
import { IconButton } from 'components/icon-button'

// `color` is honored (it used to be ignored in favor of the brand purple), so a
// caller passing 'currentColor' gets the arrow in its page's text color — on a
// list page that's the per-list textForId hue, matching the title and icons.
export const BackIcon = (color = 'var(--brand-icon)') => {

    const base = IconButton()
    base.addClass(style.base)

    const v = Bar(3, { bg: color })
    const h = Bar(3, { bg: color })

    v.style({
        transform: 'rotate(45deg) translateY(5px) translateX(4px)',
        width: '15px',
    })
    h.style({
        transform: 'rotate(-45deg) translateY(-5px)  translateX(4px)',
        width: '15px',
    })
    base.append(v, h)

    router.on('change', () => {
        if (location.pathname == '/') {
            base.removeClass(style.visible)
        } else {
            base.addClass(style.visible)
        }
    })

    base.el.onclick = () => {
        router.back()
    }


    return base
}
